export const performancereview_German= 
{
  "id": 0,
  "name": "Leistungsbewertung",
  "prompts": [
    {
      "id": 1,
      "who": "Aufgabe",
      "what": "Schreiben Sie eine Leistungsbewertung."
    },
    {
      "id": 2,
      "who": "Name",
      "what": "Eric"
    },
    {
      "id": 3,
      "who": "Titel",
      "what": "Junior-Softwareentwickler"
    },
    {
      "id": 4,
      "who": "Fristen",
      "what": "Hält sie sehr oft ein. Sein Programmieren ist fehlerfrei."
    },
    {
      "id": 5,
      "who": "Teammitglied",
      "what": "Nimmt gut teil."
    }
  ]
}


   
    export const floridaoranges_German= 
    {
      "id": 0,
      "name": "Florida Orangen",
      "prompts": [
        {
          "id": 1,
          "who": "Quartalsbericht: Produktion von Orangen in Florida",
          "what": "Quartal: Januar - März"
        },
        {
          "id": 2,
          "who": "1. Überblick:",
          "what": "Gesamtproduktion, Wetterbedingungen, Herausforderungen und zukünftige Prognosen für die Orangenindustrie im Bundesstaat"
        },
        {
          "id": 3,
          "who": "2. Gesamtproduktion von Orangen",
          "what": "Insgesamt 2,5 Millionen Kisten. 10% Steigerung gegenüber dem Vorjahreszeitraum."
        },
        {
          "id": 4,
          "who": "3. Wetterbedingungen:",
          "what": "Mäßige Temperaturen mit ausreichendem Niederschlag. Gelegentliche Kaltfronten und Frostereignisse wurden beobachtet."
        },
        {
          "id": 5,
          "who": "4. Herausforderungen:",
          "what": "Fortlaufende Bedrohung durch Zitruskrankheiten, insbesondere Zitrusgrünung. Arbeitskräftemangel. Erhöhte Produktionskosten."
        },
        {
          "id": 6,
          "who": "5. Marktnachfrage und Exporte:",
          "what": "Interesse während des ersten Quartals sowohl im Inland als auch international stabil. Erhöhter Verkauf: Europa, Kanada."
        },
        {
          "id": 7,
          "who": "6. Zukünftige Prognosen:",
          "what": "Produktion wird voraussichtlich stabil bleiben. Umsetzung von Krankheitsmanagementstrategien. Wetter genau beobachten."
        },
        {
          "id": 8,
          "who": "7. Schlussfolgerung:",
          "what": "Verfassen Sie einen Bericht auf der Grundlage der genannten Fakten. Verwenden Sie dieselben Überschriften."
        }
      ]
    }

    export const email_German= 
    {
      "id": 0,
      "name": "E-Mai",
      "prompts": [
        {
          "id": 1,
          "who": "An:",
          "what": "John Smith"
        },
        {
          "id": 2,
          "who": "Betreff: Solarpanels-Konferenz",
          "what": "Planung einer Reise nach Hawaii für die jährliche Solarpanels-Konferenz."
        },
        {
          "id": 3,
          "who": "Datum:",
          "what": "25.-29. September"
        },
        {
          "id": 4,
          "who": "Mit freundlichen Grüßen:",
          "what": "Mike Thomson"
        },
        {
          "id": 5,
          "who": "Aufgabe:",
          "what": "Schreiben Sie eine E-Mail."
        }
      ]
    }

    export const travelexpense_German= 
    {
      "id": 0,
      "name": "Reisekosten",
      "prompts": [
        {
          "id": 1,
          "who": "Titel:",
          "what": "Zeigen Sie dies als Überschrift an: Reise nach New York - Reisekosten"
        },
        {
          "id": 2,
          "who": "Transport:",
          "what": "Flugpreis: 560 $. \nTaxikosten: 156 $"
        },
        {
          "id": 3,
          "who": "Unterkunft:",
          "what": "Hotel - 2 Nächte: 350 $"
        },
        {
          "id": 4,
          "who": "Mahlzeiten:",
          "what": "Frühstück: 56 $\nMittagessen: 78 $\nAbendessen: 126 $\nSnacks: 13 $"
        },
        {
          "id": 5,
          "who": "Aufgabe:",
          "what": "Liste alle Ausgaben in einer separaten Zeile auf.\nZeige am Ende die Gesamtsumme an."
        }
      ]
    }